import { actionTypes } from 'src/redesign/features/EventsFilters/constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchEventAttendeesFilterValuesApi } from 'src/redesign/features/EventsFilters/api';
import { FetchValuesPayload } from 'src/redesign/features/EventsFilters/types';

export const fetchEventAttendeesFilterValues = createAsyncThunk(
  actionTypes.FETCH_FILTERS_VALUES,
  async ({ eventId, criteria }: FetchValuesPayload) =>
    await fetchEventAttendeesFilterValuesApi({
      eventId,
      criteria,
    }),
);

export const loadMoreOccurrences = createAsyncThunk(
  actionTypes.LOAD_MORE_OCCURRENCES,
  async ({ eventId, criteria }: FetchValuesPayload) =>
    await fetchEventAttendeesFilterValuesApi({
      eventId,
      criteria,
    }),
);
